import React, { useEffect, useState } from "react";
import { Col, Form, Dropdown } from "react-bootstrap";
import "../FormComponents.scss";
import DropdownModel from '../../../../common/model/GenericDropDownModel';
import './CustomDropDown.scss'

function DropdownCustom(props: any) {
  const { data, value, changeFunc, label, controlId, htmlFor, id, isCheckMark = false, error, classNameLabel, placeholder = "Select", cssClass = '', valueField, labelField, setInitialValue = false, ignoreLabel } = props;
  const [dataArray, setData] = useState<any[]>(Array<any>());

  const [errorMessageLabel, setErrorMessageLabel] = useState<string>("");

  useEffect(() => {
    let tempArray: DropdownModel[] = Array<DropdownModel>();
    if (valueField && labelField && data && data.length > 0) {
      data.forEach((element) => {
        tempArray.push({ Value: element[valueField], Label: element[labelField] });
      });
      setData(tempArray);
    }
    else {
      setData(data);
    }
    //Set First Item from data array inititally//
    if ((!value || value == 0 || value == 'none') && setInitialValue == true && tempArray) {
      changeFunc(tempArray[0].Value)
    }
    setErrorMessageLabel(props.label.replace('*', ''))
  }, [data])

  const onDropDownFormClick = (e) => {
    e.stopPropagation();
  }

  return (
    <div>
      {
        <Form.Group key={label} className={props.cssClass} controlId={controlId} onClick={(e) => { onDropDownFormClick(e) }}>
          <Form.Label htmlFor={htmlFor} className={`dd-label ${classNameLabel}`}>{label}</Form.Label>
          <Dropdown onSelect={changeFunc}>
            <Dropdown.Toggle className={(((!value || value == 0 || value == 'none') && !setInitialValue) ? 'dd-toggle-color-select' : '')}>
              {(!value || value == 0 || value == 'none')
                ? setInitialValue == false ? (placeholder ?? "Select") : dataArray?.find((item) => {
                  return item.Value == dataArray[0].Value;
                })?.Label
                : dataArray?.find((item) => {
                  return item.Value == value;
                })?.Label}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {dataArray?.map((item: any) => (
                <div className="menu-item-check">
                  <span className="item-checkmark">
                    {isCheckMark && value == item.Value ? (
                      <img
                        className="check-mark-icon"
                        alt="Checkmark-Icon"
                        loading="lazy"
                      ></img>
                    ) : (
                        <div className="check-mark-space"></div>
                      )}
                  </span>
                  <Dropdown.Item key={item.Value} id={id} eventKey={item.Value} value={item.Value}>
                    {item.Label}
                  </Dropdown.Item>
                </div>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          {error == true &&
            <div className="error-message-color">{props.ignoreLabel ? "Required" : `${errorMessageLabel} required.`}</div>
          }
        </Form.Group>

      }
    </div>
  );
}

export default DropdownCustom;
